import { composeWithDevTools } from '@redux-devtools/extension';
import { useDispatch } from 'react-redux';
import { applyMiddleware, combineReducers, compose, createStore, Middleware } from 'redux';
import { appReducer, INITIAL_APP_STATE } from './appSlice';
import { formReducer, INITIAL_FORM_STATE } from './formSlice';
import { INITIAL_RESIT_STATE, resitReducers } from './resitSlice';
import { injectStore } from '../api-refactored/axiosClient';

const isProduction = import.meta.env.PROD;

// =============================================================================
// Root Reducer
// =============================================================================
const rootReducer = combineReducers({
  app: appReducer,
  resit: resitReducers,
  form: formReducer,
});

export type RootState = ReturnType<typeof rootReducer>;

// =============================================================================
// Store
// =============================================================================
export const INIT_STATE: RootState = {
  app: INITIAL_APP_STATE,
  resit: INITIAL_RESIT_STATE,
  form: INITIAL_FORM_STATE,
};

function configureStore(initialState: RootState = INIT_STATE) {
  const middlewares: Middleware[] = [];

  const enhancers = isProduction
    ? compose(applyMiddleware(...middlewares))
    : composeWithDevTools(applyMiddleware(...middlewares));
  const configStore = createStore(rootReducer, initialState, enhancers);

  return configStore;
}

// Injecting store for use in Axios Interceptor
const store = configureStore();
injectStore(store);

// Giving dispatch better typing
export const useAppDispatch = () => useDispatch<ReturnType<typeof configureStore>['dispatch']>();
export default store;
